import React from "react";
import Laptop from "../assets/laptop.jpg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Analytics = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div id={id} className="w-full bg-[#F0F8FF] py-1 px-4 ">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        <img
          className="w-[500px] mx-auto my-4"
          src={Laptop}
          alt={t("analytics.imgAlt", "Laptop showing data analytics")}
          data-aos="fade-right"
        />
        <div className="flex flex-col justify-center" data-aos="fade-left">
          <h1 className="md:text-2xl sm:text-2xl text-xl font-bold py-2">
            {t("analytics.title")}
          </h1>
          <p className="text-gray-700 mb-4">{t("analytics.desc")}</p>
          <Link
            to="/nos-expertises"
            className="bg-[#00171f] text-[#00df9a] text-center w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3"
            data-aos="fade-up"
          >
            {t("analytics.cta")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
